// Single source of truth for Special Machines.
// Add new entries here and they will automatically appear on:
//  - /solutions (Special Machines grid)
//  - Home page Featured Projects carousel
export type SpecialMachine = {
  en: string;
  sl: string;
  image: string;
  href: string;
};

export const specialMachines: SpecialMachine[] = [
  {
    en: "Industrial Pedestal Welders",
    sl: "Industrijski stacionarni varilni stroji",
    image: "/products/pedestal-a135.webp",
    href: "/products/industrial-pedestal-welders",
  },
  {
    en: "Invisible Welding Machine",
    sl: "Stroj za nevidno varjenje",
    image: "/products/invisible-welding.webp",
    href: "/products/industrial-projection-welders",
  },
  {
    en: "Industrial Seam Welders",
    sl: "Industrijski stroji za kolutno varjenje",
    image: "/products/seam-welder-hero.webp",
    href: "/products/industrial-seam-welders",
  },
  {
    en: "Multi Spot Welding Machine",
    sl: "Večtočkovni varilni stroj",
    image: "/products/multispot-a141.webp",
    href: "/products/multi-spot-welding-machine",
  },
  {
    en: "Robotic Spot Welding Guns",
    sl: "Robotske točkovne varilne pištole",
    image: "/solutions/rrwg-2002.webp",
    href: "/solutions/robotic-spot-welding-guns",
  },
  {
    en: "Lock Welding",
    sl: "Varjenje ključavnic",
    image: "/solutions/lock-welding-stublina.png",
    href: "/solutions/lock-welding",
  },
  {
    en: "Tension Ring Welding",
    sl: "Varjenje zateznih obročev",
    image: "/solutions/tension-ring-welding-machine.webp",
    href: "/solutions/tension-ring-welding",
  },
  {
    en: "Welding machine for barrel handles",
    sl: "Stroj za varjenje ročic na sode",
    image: "/solutions/barrel-handle-welding-machine.png",
    href: "/solutions/barrel-handle-welding",
  },
  {
    en: "Welding machine for tapping barrels",
    sl: "Stroj za varjenje natočnih sodov",
    image: "/solutions/tapping-barrel-welding-machine.png",
    href: "/solutions/tapping-barrel-welding",
  },
  {
    en: "Welding machine for protective mesh",
    sl: "Stroj za varjenje zaščitnih mrež",
    image: "/solutions/protective-mesh-welding-machine.png",
    href: "/solutions/protective-mesh-welding",
  },
  {
    en: "Welding machine for oil tanks",
    sl: "Stroj za varjenje rezervoarjev za nafto",
    image: "/solutions/oil-tank-welding-machine.png",
    href: "/solutions/oil-tank-welding",
  },
  {
    en: "Double-sided seam welding machine for ovens",
    sl: "Dvostranski kolutni varilni stroj za varjenje pečic",
    image: "/solutions/double-sided-seam-welding-ovens.png",
    href: "/solutions/double-sided-seam-oven-welding",
  },
  {
    en: "Welding machine for chimney elbows",
    sl: "Stroj za varjenje dimniških kolen",
    image: "/solutions/chimney-elbow-welding-machine.png",
    href: "/solutions/chimney-elbow-welding",
  },
  {
    en: "Machine for destructive testing of oil barrel welds",
    sl: "Stroj za porušitveni test zvarov naftnih sodov",
    image: "/solutions/weld-destructive-test-machine.png",
    href: "/solutions/weld-destructive-test",
  },
  {
    en: "Welding machine for aluminum frames for the automotive industry",
    sl: "Stroj za varjenje aluminijastih okvirjev za avtomobilsko industrijo",
    image: "/solutions/aluminum-frame-welding-machine.png",
    href: "/solutions/aluminum-frame-welding",
  },
  {
    en: "Seam welding machine for door profiles",
    sl: "Stroj za kolutno varjenje vratnega profila",
    image: "/solutions/door-profile-seam-welding-machine.webp",
    href: "/solutions/door-profile-seam-welding",
  },
  {
    en: "Nut welding machine",
    sl: "Stroj za varjenje matic",
    image: "/solutions/nut-welding-machine.webp",
    href: "/solutions/nut-welding",
  },
];
